<template>
  <div>
    <MultiselectDropdown
      :label="$t('COUPON.ADD_FORM.TYPE_FORM.DISCOUNT_TYPE.LABEL')"
      :error="$v.coupon.discount_type_index.$error  ? $t('COUPON.ADD_FORM.TYPE_FORM.DISCOUNT_TYPE.ERROR'):''"
    >
      <RadioList
        v-model="coupon.discount_type_index"
        :options="discount_types"
        :classWrapper="'couponOptions'"
      />
    </MultiselectDropdown>
    <InputField
      v-model="coupon.discount_value"
      :label="$t('COUPON.ADD_FORM.TYPE_FORM.VALUE_DISCOUNT.LABEL')"
      :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.VALUE_DISCOUNT.PLACEHOLDER')"
      type="number"
      :error="$v.coupon.discount_value.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.VALUE_DISCOUNT.ERROR') : ''"
      :infoList="[]"
      :textLength="coupon.discount_value"
      :classNamePostFix="'uppercase'"
      :postFix="coupon.discount_type_index === 0 ?'%': currentAccount.currency"
      @blur="$v.coupon.discount_value.$touch"
    />

    <div class="duration_wrap mb_16">
      <div :class="isRedemMultipleMonth? 'duration_fields':''">
        <MultiselectDropdown
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.DURATION.LABEL')"
          :infoList="[]"
          :error="$v.coupon.redeemed_type.$error ? '' : ''"
        >
          <multiselect
            class="column small-12"
            v-model="coupon.redeemed_type"
            :options="redeemed_list"
            track-by="id"
            label="title"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.DURATION.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          />
        </MultiselectDropdown>

        <InputField
          v-if="isRedemMultipleMonth"
          v-model="coupon.limit_per_month"
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.MONTHS.LABEL')"
          :placeholder="''"
          type="number"
          :error="$v.coupon.limit_per_month.$error ? '' : ''"
          :infoList="[]"
          :textLength="coupon.limit_per_month"
          :postFix="$t('COUPON.ADD_FORM.TYPE_FORM.MONTHS.POST_FIX')"
          @blur="$v.coupon.limit_per_month.$touch"
        />
      </div>
      <div v-if="$v.coupon.redeemed_type.$error || $v.coupon.limit_per_month.$error" class="error text_12 font_500 " :style="{'margin-top': !isRedemMultipleMonth ? '-10px':null}">
        {{$v.coupon.redeemed_type.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.DURATION.ERROR') : ''}}
        {{$v.coupon.limit_per_month.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.MONTHS.ERROR') : ''}}
      </div>
      <div v-else class="hint text_12 font_500 text_black_secondary" :style="{'margin-top': !isRedemMultipleMonth ? '-10px':null}">
        {{$t('COUPON.ADD_FORM.TYPE_FORM.DURATION.HINT')}}
      </div>
    </div>

    <div>
      <label class="font_regular font_500 text_12 mb_8">
        {{$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LABEL')}}
      </label>
      <CheckboxInput
        v-model="coupon.date_range_limit"
        :classNameWrapper="'redemp_check_label'"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_DATE.CHECKBOX_LABEL')"
        @onToggle="onToggleDateRange"
      />

      <div v-if="coupon.date_range_limit" class="ml_24">
        <MultiselectDropdown
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_DATE.LABEL')"
          :error="isRedemDateTimeErr? $t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_DATE.ERROR'):''"
          :infoList="[]"
        >
        <div class="redemption">
            <WootDateTimePicker
              :value="coupon.redemp_date"
              style="margin-top:'8px'"
              :disable-dates="0"
              :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
              :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
              displayFormat="ddd, DD MMM YYYY"
              type="date"
              @change="onRedempDateChange"
            />
            <WootDateTimePicker
              :value="coupon.redemp_time"
              style="margin-top:'8px'"
              :disable-dates="0"
              :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
              :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
              displayFormat="hh:mmA"
              type="time"
              @change="onRedempTimeChange"
            />
        </div>
        </MultiselectDropdown>
      </div>
    </div>

    <div>
      <CheckboxInput
        v-model="coupon.is_redemp_limit"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.CHECKBOX_LABEL')"
        :classNameWrapper="'redemp_check_label'"
        @onToggle="onToggleRedempLimit"
      />
      <div v-if="coupon.is_redemp_limit" class="redemption ml_24">
        <div>
          <InputField
          v-model="coupon.redeemed_limit"
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.LABEL')"
          :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.PLACEHOLDER')"
          :error="$v.coupon.redeemed_limit.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.ERROR') : ''"
          type="number"
          :infoList="[]"
          :textLength="coupon.redeemed_limit"
          :postFix="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.POST_FIX')"
          @blur="$v.coupon.redeemed_limit.$touch"
        />
        </div>
        <div></div>
      </div>
    </div>

    <div class="submit_btns">
      <woot-button
        color-scheme="primary" size="small" :style="{width:'100%'}"
        variant="outline"
        :is-loading="false"
        :is-disabled="false"
        @click="onBack"
      >
        {{$t('COUPON.ADD_FORM.TYPE_FORM.BTNS.BACK')}}
      </woot-button>
      <woot-button
        color-scheme="primary" size="small" :style="{width:'100%'}"
        :is-loading="false"
        :is-disabled="false"
        @click="onNext"
      >
        {{$t('COUPON.ADD_FORM.TYPE_FORM.BTNS.NEXT')}}
      </woot-button>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength,minValue  } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import Spinner from 'shared/components/Spinner.vue';
import RadioList from "../../../../dashboard/arrange/RadioList.vue"
import MultiselectDropdown from "../../../../../components/ui/inputs/MultiselectDropdown.vue"
import InputField from '../../../../../components/ui/inputs/InputField.vue';
import ToggleField from '../../../../../components/ui/inputs/ToggleField.vue';
import CheckboxInput from '../../../../../components/ui/inputs/CheckboxInput.vue';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';


export default {
  components: {
    RadioList,
    MultiselectDropdown,
    InputField,
    ToggleField,
    CheckboxInput,
    WootDateTimePicker,
  },
  mixins: [alertMixin],
  props:{
    coupon:{
      type: Object,
    },
    discount_types:{
      type: Array,
      default: []
    },
    redeemed_list:{
      type: Array,
      default: []
    },
  },
  data(){
    return {

    }
  },
  computed:{
    ...mapGetters({
      currentUser: "getCurrentUser",
      getAccount: 'accounts/getAccount',
    }),
    currentAccount(){
      return this.getAccount(this.currentUser.account_id);
    },
    isRedemMultipleMonth(){
      return this.coupon.redeemed_type?.id   === 'multiple_month';
    },
    isRedemDateTimeErr(){
      if (this.coupon.date_range_limit) {
        if (!this.coupon.redemp_date || !this.coupon.redemp_time) {
          return true;
        }
      }
      return false;
    },
  },
  validations:{
    coupon:{
      discount_value:{
        required,
        minLength: minLength(1),
        minValue: minValue(1),
      },
      limit_per_month:{
        required
      },
      redeemed_type:{
        required
      },
      redeemed_limit:{
        required
      },
      discount_type_index:{
        required
      },
    },
  },
  methods:{
    onNext(){
      this.$v.$touch();
        if (this.$v.$invalid) {
          console.log(this.$v.coupon);
          return;
        }
        if (this.isRedemDateTimeErr) {
          return
        }
      const nextStep = 3;
      this.$emit('onNext', nextStep)
    },
    onBack(){
      const backStep = 1;
      this.$emit('onBack', backStep)
    },
    onToggleDateRange(value){
      console.log(value);
      if (!value) {
        this.coupon.redemp_date = null;
        this.coupon.redemp_time = null;
      }
      this.coupon.date_range_limit = value;
    },
    onRedempDateChange(value){
      this.coupon.redemp_date = value;
    },
    onRedempTimeChange(value){
      this.coupon.redemp_time = value;
    },
    onToggleRedempLimit(value){
      if (!value) {
        this.coupon.redeemed_limit = 0;
      }
      this.coupon.is_redemp_limit = value;
    },
  },
}
</script>




<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.couponOptions{
    /* margin-top: 4px; */
    display: flex;
    gap: 24px;
}


.duration_wrap{
  .duration_fields{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 16px;
  }
  .hint{
    margin-top: -28px;
  }
  .error{
    margin-top: -27px;
    color: red;
  }
}

.redemption{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 8px;
}

.redemp_check_label{
  margin-bottom: 8px;
}

.submit_btns{
  display: flex;
  gap: 20px;
  margin-top: 24px;
}
</style>

<style>
.couponOptions .radio-item{
    gap: 0;
}
.couponOptions .radio_label_wrap{
    margin-bottom: 2px;
}
.couponOptions .radio_label{
    font-weight: 500;
    color: #304352;
}
.couponOptions .radio_description{
    font-weight: 500;
    color: #858585;
    font-size: 12px;
}


</style>